// extracted by mini-css-extract-plugin
export default {"hiddenProgress":"Stepper_hiddenProgress__gThAq"};